import { useState, useEffect } from 'react';
import useLocalStorage from './useLocalStorage';
import { supabase } from '../lib/supabaseClient';

export type Language = 'fr' | 'en' | 'es' | 'de' | 'it' | 'pt' | 'nl';

interface LanguageData {
  [key: string]: any;
}

export const useLanguage = () => {
  const [language, setStoredLanguage] = useLocalStorage<Language>('lilhero_language', 'fr');
  const [, forceUpdate] = useState({});

  const setLanguage = (lang: Language) => {
    setStoredLanguage(lang);
    // Force re-render of all components using this hook
    forceUpdate({});

    // Sync language to Supabase user_metadata (for email templates)
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (user) {
        supabase.auth.updateUser({ data: { lang } }).then(({ error }) => {
          if (error) {
            console.warn('⚠️ Could not sync language to user:', error.message);
          } else {
            console.log('🌐 Language synced to user_metadata:', lang);
          }
        });
      }
    });
  };

  const translate = (data: LanguageData, key?: string): string => {
    if (!data || typeof data !== 'object') return '';
    
    const langData = data[language] || data.fr || data.en || data[Object.keys(data)[0]];
    if (!langData) return '';
    
    if (key) {
      return langData[key] || '';
    }
    
    if (typeof langData === 'string') {
      return langData;
    }
    
    return langData.name || langData.title || langData.text || '';
  };

  return {
    language,
    setLanguage,
    translate
  };
};